import { makeAutoObservable } from "mobx";
import { UserNoteController } from "../UserNoteController";
import { FulfillmentTimeController } from "../FulfillmentTimeController";
import { FulfillmentMethodController } from "../FulfillmentMethodController";
import { RArray } from "../../../collections";
export class OnlineFulfillmentFormController {
    constructor(params) {
        this.type = "Online";
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.fulfillmentTimeController = new FulfillmentTimeController({
            purchaseOrderFulfillmentTime: params.purchaseOrderFulfillmentTime,
            fulfillmentInstructions: params.fulfillmentInstructions,
            fulfillmentTime: params.fulfillmentTime,
        });
        this.fulfillmentMethodController = new FulfillmentMethodController({
            fulfillmentInstructions: params.fulfillmentInstructions,
            geocodingService: params.geocodingService,
            geolocationService: params.geolocationService,
            viewType: params.viewType,
        });
        this.userNoteController = new UserNoteController({
            fulfillmentInstructions: params.fulfillmentInstructions,
        });
        makeAutoObservable(this);
    }
    get fields() {
        return {
            ...this.fulfillmentTimeController.fields,
            ...this.fulfillmentMethodController.fields,
            ...this.userNoteController.fields,
        };
    }
    get controllersArray() {
        return new RArray([
            this.fulfillmentTimeController,
            this.fulfillmentMethodController,
            this.userNoteController,
        ]);
    }
    get isDirty() {
        return this.controllersArray.some((controller) => controller.isDirty);
    }
    get isTouched() {
        return this.controllersArray.some((controller) => controller.isTouched);
    }
    get isInvalid() {
        return this.controllersArray.some((controller) => controller.isInvalid);
    }
    get isValid() {
        return !this.isInvalid;
    }
    get domain() {
        return this.fulfillmentInstructions;
    }
    submit() {
        this.controllersArray.forEach((controller) => controller.submit());
    }
}
